import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=d6c8e6c0&scoped=true&"
import script from "./HeaderBar.vue?vue&type=script&lang=js&"
export * from "./HeaderBar.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBar.vue?vue&type=style&index=0&id=d6c8e6c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c8e6c0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NotificationCard: require('/builds/mytia/mege-educacional/components/NotificationCard.vue').default,AppDropdownProfile: require('/builds/mytia/mege-educacional/components/AppDropdownProfile.vue').default})
